module.exports = __webpack_public_path__ + "img/finvivir.5b2cd3aa.svg";